import PropTypes from "prop-types"
import { Alert, Button } from "@mui/material"
import { Refresh } from "@mui/icons-material"
import { QUICK_ANSWERS_ERRORS } from "hooks/ai-quick-answers"

export default function ErrorDisplay({ errorState, onRetry }) {
  const { type } = errorState ?? {}
  if (!type) return null

  // User-friendly messages for all users
  const getErrorMessage = (type) => {
    switch (type) {
      // Always use generic message, never show original AI error
      case QUICK_ANSWERS_ERRORS.AI_ERROR:
      case QUICK_ANSWERS_ERRORS.NO_RESULTS:
      case QUICK_ANSWERS_ERRORS.BAD_QUESTION:
        return "Sorry, I'm unable to answer your question. Try to rephrase it or try a different approach."
      case QUICK_ANSWERS_ERRORS.PORTFOLIO_ONLY:
        return "Sorry, I can only answer questions about portfolios."
      default:
        return "An unexpected error occurred. Please try again."
    }
  }

  const getSeverity = (type) => {
    switch (type) {
      case QUICK_ANSWERS_ERRORS.NO_RESULTS:
      case QUICK_ANSWERS_ERRORS.AI_ERROR:
      case QUICK_ANSWERS_ERRORS.BAD_QUESTION:
        return "info"
      case QUICK_ANSWERS_ERRORS.PORTFOLIO_ONLY:
        return "warning"
      default:
        return "error"
    }
  }

  const canRetry = (type) => {
    return QUICK_ANSWERS_ERRORS.SERVER_ERROR === type
  }

  const errorMessage = getErrorMessage(type)
  const severity = getSeverity(type)
  const showRetry = canRetry(type) && onRetry

  const handleRetry = () => {
    // TODO: Track error retry clicked event (but don't include original message)
    onRetry()
  }

  return (
    <Alert
      severity={severity}
      sx={{ width: "100%", mb: 2 }}
      action={
        showRetry ? (
          <Button
            color="inherit"
            size="small"
            startIcon={<Refresh />}
            onClick={handleRetry}
          >
            Retry
          </Button>
        ) : null
      }
    >
      {errorMessage}
    </Alert>
  )
}

ErrorDisplay.propTypes = {
  errorState: PropTypes.shape({
    type: PropTypes.oneOf([
      QUICK_ANSWERS_ERRORS.AI_ERROR,
      QUICK_ANSWERS_ERRORS.NO_RESULTS,
      QUICK_ANSWERS_ERRORS.SERVER_ERROR,
      QUICK_ANSWERS_ERRORS.BAD_QUESTION,
    ]).isRequired,
    message: PropTypes.string,
  }),
  onRetry: PropTypes.func,
}
